import { RaterAnswers } from '@/modules/common/rater/models/APP/RaterAnswers'

export default class HealthRaterAnswers extends RaterAnswers {
  insuranceType: string | null
  copayType: string | null
  abroadOption: string | null
  coverage: string | null

  constructor(data: Partial<HealthRaterAnswers> = {}) {
    super(data)

    this.forWhom = data.forWhom
    this.forWhomPeople = data.forWhomPeople ?? 1
    this.insuranceType = data.insuranceType ?? null //'1' WEB-49
    this.copayType = data.copayType ?? null
    this.abroadOption = data.abroadOption ?? null
    this.coverage = data.coverage ?? null
  }
}
